<!--
  ~ Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<well-subscription-card-view class='subscription-type'
                             [subscription]='subscription'>
  <div class='ribbon d-flex justify-content-center align-items-center' [ngStyle]='getRibbonColor()' ribbon>
    @if (subscription?.companyType; as companyType) {
      {{ translation.get(companyType) }}
    }
  </div>
  <ng-content></ng-content>
</well-subscription-card-view>


